<template>
    <div v-if="enlargeClicked == true" id="enlarge-container" class="enlarge-container">
        <section
            v-click-outside="outsidePopup"
            class="selected-image"
            role="dialog"
            aria-modal="true"
            :aria-label="'Images for ' + currentTitle"
        >
            <header class="enlarge-header">
                <div class="enlarge-title-block">
                    <span class="enlarge-kicker">{{ currentTypeLabel }}</span>
                    <h3 class="enlarge-title">{{ currentTitle }}</h3>
                </div>
                <button type="button" @click="close" class="close enlarge-close" aria-label="Close image gallery">
                    <span class="icon icon-cross"></span>
                </button>
            </header>
            <div class="enlarge-body" :class="{ 'no-thumbnails': !thumbnailUrls.length }">
                <div class="large-img-stage">
                    <div
                        v-if="currentItem != null"
                        :style="{ backgroundImage: 'url(' + selectedImageUrl + ')' }"
                        class="large-img"
                    ></div>
                </div>
                <aside v-if="thumbnailUrls.length" class="thumbnail-table" aria-label="Product images">
                    <button
                        v-for="(image, index) in thumbnailUrls"
                        :key="image + '-' + index"
                        type="button"
                        @click="markSelected(image)"
                        class="img-thumbnail"
                        :class="{ 'is-selected': isSelectedImage(image) }"
                        :aria-label="'View product image ' + (index + 1)"
                        :style="{ backgroundImage: 'url(' + image + ')' }"
                    ></button>
                </aside>
            </div>
        </section>
    </div>
</template>

<script>
import { EventBus } from '../../eventBus'
import ClickOutside from 'vue-click-outside'

export default {
    name: "Enlarge",
    data () {
        return {
            image: null,
            enlargeClicked: false,
            mounted: false,
            currentItem: null,
        }
    },
    computed: {
        currentTitle(){
            if(!this.currentItem){
                return 'Product images'
            }
            var brand = this.currentItem.brand ? this.currentItem.brand + ' ' : ''
            return (brand + (this.currentItem.model || 'Product images')).trim()
        },
        currentTypeLabel(){
            if(!this.currentItem || !this.currentItem.type){
                return 'Gallery'
            }
            if(this.currentItem.type == 'gpu' || this.currentItem.type == 'graphics'){
                return 'Graphics'
            }
            if(this.currentItem.type == 'psu'){
                return 'Power supply'
            }
            return String(this.currentItem.type).charAt(0).toUpperCase() + String(this.currentItem.type).slice(1)
        },
        selectedImageUrl(){
            if(!this.currentItem){
                return ''
            }
            return this.getSelectedImg(this.currentItem.imgUrl)
        },
        thumbnailUrls(){
            if(!this.currentItem){
                return []
            }
            return this.getThumbnailUrls(this.currentItem.imgUrl)
        },
    },
    methods: {
        close(){
            this.enlargeClicked = false
            this.mounted = false
            this.unselect()
        },
        outsidePopup(){
            if(this.mounted == true && this.enlargeClicked == true){
                this.close()
            }
            return 
        },
        getSelectedImg(imgUrl){
            if(this.image !==null){
                return this.fullResAmazon(this.image)
            }
            var array = this.parseUrls(imgUrl)
            return this.fullResAmazon(array[1] || array[0] || '')
        },
        // Amazon media URLs embed a resize directive before the extension
        // (e.g. "61abc._AC_SX466_.jpg"). The enlarge view stretches that smaller
        // variant up, which reads as blurry. Stripping the directive returns the
        // original full-resolution image — same framing, nothing cropped, just
        // sharper. Non-Amazon URLs pass through untouched.
        fullResAmazon(url){
            if(typeof url !== 'string' || !url){
                return url
            }
            if(!/(?:media-amazon|images-amazon|ssl-images-amazon)\.com/i.test(url)){
                return url
            }
            return url.replace(/\._[A-Za-z0-9_,-]+_\.(jpg|jpeg|png|gif|webp)(\?.*)?$/i, '.$1$2')
        },
        parseUrls(urls){
            try {
                var arr = JSON.parse(urls)
                return Array.isArray(arr) ? arr : []
            } catch (e) {
                return []
            }
        },
        getItemUrls(urls){
            // Thumbnails stay at their small variant on purpose (fast strip);
            // only the main enlarged image is upgraded to full resolution.
            return this.parseUrls(urls)
        },
        getThumbnailUrls(urls){
            var images = this.getItemUrls(urls)
            if(images.length > 1){
                return images.slice(1)
            }
            return images
        },
        isSelectedImage(image){
            return this.fullResAmazon(image) == this.selectedImageUrl
        },
        unselect(){
            this.image = null
        },
        markSelected(image){
            this.image = image
        },
        handleEnlarge(item){
            this.currentItem = item
            this.enlargeClicked = true
            setTimeout(() => {
                this.mounted = true
            }, 1000)
        },
    },
    beforeDestroy(){
        EventBus.$off('enlarge', this.handleEnlarge)
        this.image = null
    },
    mounted(){
        EventBus.$on('enlarge', this.handleEnlarge)
    },
    directives: {
        ClickOutside
    },
}
</script>
<style scoped>
.enlarge-container {
    position: fixed;
    inset: 0;
    z-index: 100000;
    display: grid;
    place-items: center;
    padding: clamp(14px, 3vw, 36px);
    background:
        radial-gradient(circle at 14% 0%, rgba(25, 151, 198, 0.16), rgba(25, 151, 198, 0) 34%),
        rgba(0, 0, 0, 0.78);
    backdrop-filter: blur(4px);
}

.selected-image {
    display: grid !important;
    grid-template-rows: auto minmax(0, 1fr);
    width: min(1310px, calc(100vw - 48px));
    height: min(850px, calc(100vh - 48px));
    max-width: none !important;
    overflow: hidden;
    border: 1px solid rgba(67, 72, 87, 0.88);
    border-radius: 10px;
    background:
        linear-gradient(180deg, rgba(20, 24, 33, 0.98), rgba(12, 15, 22, 0.98)),
        #191b20 !important;
    box-shadow:
        0 26px 70px rgba(0, 0, 0, 0.56),
        inset 0 1px 0 rgba(255, 255, 255, 0.035);
}

.enlarge-header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 16px;
    min-height: 58px;
    padding: 11px 14px 10px 16px;
    border-bottom: 1px solid rgba(67, 72, 87, 0.72);
    background:
        linear-gradient(90deg, rgba(25, 151, 198, 0.1), rgba(25, 151, 198, 0)),
        rgba(8, 10, 15, 0.58);
}

.enlarge-title-block {
    min-width: 0;
}

.enlarge-kicker {
    display: block;
    color: #20c8f8;
    font-size: 10px;
    font-weight: 900;
    letter-spacing: 0.12em;
    line-height: 1;
    text-transform: uppercase;
}

.enlarge-title {
    overflow: hidden;
    margin: 5px 0 0;
    color: #dce2ee;
    font-size: 17px;
    font-weight: 700;
    letter-spacing: 0;
    line-height: 1.15;
    text-overflow: ellipsis;
    white-space: nowrap;
}

.enlarge-close {
    position: static !important;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    flex: 0 0 auto;
    width: 36px;
    height: 36px;
    padding: 0;
    border: 1px solid rgba(67, 72, 87, 0.88);
    border-radius: 8px;
    background: rgba(8, 10, 15, 0.62);
    color: #9198aa;
    font-size: 15px;
    line-height: 1;
    float: none !important;
    opacity: 1 !important;
    text-shadow: none;
    transition: background 160ms ease, border-color 160ms ease, color 160ms ease, box-shadow 160ms ease;
}

.enlarge-close:hover,
.enlarge-close:focus {
    border-color: rgba(32, 200, 248, 0.76);
    background: rgba(25, 151, 198, 0.12);
    color: #f4f8fb;
    box-shadow: 0 0 18px rgba(25, 151, 198, 0.12);
}

.enlarge-body {
    display: grid;
    grid-template-columns: minmax(0, 1fr) 184px;
    gap: 16px;
    min-height: 0;
    padding: 16px;
}

.enlarge-body.no-thumbnails {
    grid-template-columns: minmax(0, 1fr);
}

.large-img-stage {
    min-width: 0;
    min-height: 0;
    overflow: hidden;
    border: 1px solid rgba(67, 72, 87, 0.62);
    border-radius: 8px;
    background:
        linear-gradient(180deg, #f8fafc, #eef2f6);
    box-shadow:
        inset 0 0 0 1px rgba(255, 255, 255, 0.72),
        0 16px 34px rgba(0, 0, 0, 0.18);
}

.large-img {
    width: 100% !important;
    height: 100% !important;
    min-height: 320px;
    border-radius: 0;
    background-position: center;
    background-repeat: no-repeat;
    background-size: contain;
}

.thumbnail-table {
    display: flex !important;
    flex-direction: column;
    gap: 12px;
    min-width: 0;
    min-height: 0;
    padding: 1px 6px 1px 0;
    overflow-x: hidden;
    overflow-y: auto;
    text-align: left;
    scrollbar-width: thin;
    scrollbar-color: rgba(25, 151, 198, 0.55) rgba(8, 10, 15, 0.24);
}

.thumbnail-table::-webkit-scrollbar {
    display: block !important;
    width: 7px;
}

.thumbnail-table::-webkit-scrollbar-track {
    background: rgba(8, 10, 15, 0.24);
}

.thumbnail-table::-webkit-scrollbar-thumb {
    border-radius: 999px;
    background: rgba(25, 151, 198, 0.55);
}

.img-thumbnail {
    flex: 0 0 auto;
    width: 100% !important;
    height: 130px !important;
    margin: 0 !important;
    padding: 0;
    border: 1px solid rgba(67, 72, 87, 0.72);
    border-radius: 8px;
    background-color: #f8fafc;
    background-position: center;
    background-repeat: no-repeat;
    background-size: contain;
    box-shadow: inset 0 0 0 1px rgba(255, 255, 255, 0.55);
    transition: border-color 160ms ease, box-shadow 160ms ease, transform 160ms ease;
}

.img-thumbnail:hover,
.img-thumbnail:focus,
.img-thumbnail.is-selected {
    border-color: rgba(32, 200, 248, 0.86);
    box-shadow:
        0 0 18px rgba(25, 151, 198, 0.18),
        inset 0 0 0 1px rgba(255, 255, 255, 0.62);
}

.img-thumbnail:hover,
.img-thumbnail:focus {
    transform: translateY(-1px);
}

@media screen and (max-width: 900px) {
    .selected-image {
        width: calc(100vw - 24px);
        height: calc(100vh - 24px);
    }

    .enlarge-body {
        grid-template-columns: minmax(0, 1fr);
        grid-template-rows: minmax(0, 1fr) auto;
        gap: 12px;
        padding: 12px;
    }

    .thumbnail-table {
        flex-direction: row;
        padding: 0 0 6px;
        overflow-x: auto;
        overflow-y: hidden;
    }

    .thumbnail-table::-webkit-scrollbar {
        width: auto;
        height: 7px;
    }

    .img-thumbnail {
        width: 108px !important;
        height: 82px !important;
    }
}

@media screen and (max-width: 520px) {
    .enlarge-container {
        padding: 8px;
    }

    .selected-image {
        width: calc(100vw - 16px);
        height: calc(100vh - 16px);
        border-radius: 8px;
    }

    .enlarge-header {
        min-height: 54px;
        padding: 9px 10px 9px 12px;
    }

    .enlarge-title {
        font-size: 14px;
    }

    .large-img {
        min-height: 250px;
    }

    .img-thumbnail {
        width: 92px !important;
        height: 72px !important;
    }
}
</style>
